import { BetTypeSelectionSBVSelectionType, BetTypeOutcomeShowType } from './enums';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const TestModel = Object.freeze({
  betTypeSelections: [

    // fudbal
    {
      id: 1,
      betProductPageId: 3,
      sportId: 1,
      betTypeId: 135,
      hasSBV: false,
      betTypeName: 'Konacan ishod',
      sbvSelectionType: BetTypeSelectionSBVSelectionType.None,
      sbvExactValue: null,
      orderNumber: 1,
      isSelected: false,
      betTypeOutcomes: [
        {
        id: 424,
        name: '1',
        shortName: '1',
        orderNumber: 1,
        betTypeId: 135,
        terminalShowType: BetTypeOutcomeShowType.BTOShortName,
        desktopShowType: BetTypeOutcomeShowType.BTOShortName,
        mobileShowType: BetTypeOutcomeShowType.BTOShortName,
        customName: '',
        descriptions: '',
      },
      {
        id: 425,
        name: 'X',
        shortName: 'X',
        orderNumber: 2,
        betTypeId: 135,
        terminalShowType: BetTypeOutcomeShowType.BTOShortName,
        desktopShowType: BetTypeOutcomeShowType.BTOShortName,
        mobileShowType: BetTypeOutcomeShowType.BTOShortName,
        customName: '',
        descriptions: '',
      },
      {
        id: 426,
        name: '2',
        shortName: '2',
        orderNumber: 3,
        betTypeId: 135,
        terminalShowType: BetTypeOutcomeShowType.BTOShortName,
        desktopShowType: BetTypeOutcomeShowType.BTOShortName,
        mobileShowType: BetTypeOutcomeShowType.BTOShortName,
        customName: '',
        descriptions: '',
      }
    ],
    },
    {
      id: 2,
      betProductPageId: 3,
      sportId: 1,
      betTypeId: 137,
      hasSBV: true,
      betTypeName: 'Ukupno golova',
      sbvSelectionType: BetTypeSelectionSBVSelectionType.MostBalanced,
      sbvExactValue: '2.5',
      orderNumber: 2,
      isSelected: false,
      betTypeOutcomes: [
        {
          id: 429,
          name: 'Manje',
          shortName: 'M',
          orderNumber: 1,
          betTypeId: 137,
          terminalShowType: BetTypeOutcomeShowType.BTOFullName,
          desktopShowType: BetTypeOutcomeShowType.BTOFullName,
          mobileShowType: BetTypeOutcomeShowType.BTOFullName,
          customName: '',
          descriptions: '',
        },
        {
          id: 430,
          name: 'Vise',
          shortName: 'V',
          orderNumber: 2,
          betTypeId: 137,
          terminalShowType: BetTypeOutcomeShowType.BTOFullName,
          desktopShowType: BetTypeOutcomeShowType.BTOFullName,
          mobileShowType: BetTypeOutcomeShowType.BTOFullName,
          customName: '',
          descriptions: '',
        }
      ],
    },
    // kosarka
    {
      id: 3,
      betProductPageId: 3,
      sportId: 2,
      betTypeId: 189,
      hasSBV: false,
      betTypeName: 'Konacan ishod',
      sbvSelectionType: BetTypeSelectionSBVSelectionType.None,
      sbvExactValue: null,
      orderNumber: 1,
      isSelected: false,
      betTypeOutcomes: [
        {
          id: 754,
          name: '1',
          shortName: '1',
          orderNumber: 1,
          betTypeId: 189,
          terminalShowType: BetTypeOutcomeShowType.BTOShortName,
          desktopShowType: BetTypeOutcomeShowType.BTOShortName,
          mobileShowType: BetTypeOutcomeShowType.BTOShortName,
          customName: '',
          descriptions: '',
        },
        {
          id: 755,
          name: 'X',
          shortName: 'X',
          orderNumber: 2,
          betTypeId: 189,
          terminalShowType: BetTypeOutcomeShowType.BTOShortName,
          desktopShowType: BetTypeOutcomeShowType.BTOShortName,
          mobileShowType: BetTypeOutcomeShowType.BTOShortName,
          customName: '',
          descriptions: '',
        },
        {
          id: 756,
          name: '2',
          shortName: '2',
          orderNumber: 3,
          betTypeId: 189,
          terminalShowType: BetTypeOutcomeShowType.BTOShortName,
          desktopShowType: BetTypeOutcomeShowType.BTOShortName,
          mobileShowType: BetTypeOutcomeShowType.BTOShortName,
          customName: '',
          descriptions: '',
        }
      ],
    },
    {
      id: 4,
      betProductPageId: 3,
      sportId: 2,
      betTypeId: 190,
      hasSBV: true,
      betTypeName: 'Ukupno poena M',
      sbvSelectionType: BetTypeSelectionSBVSelectionType.MostBalanced,
      sbvExactValue: '163.5',
      orderNumber: 2,
      isSelected: false,
      betTypeOutcomes: [
        {
          id: 757,
          name: 'Manje',
          shortName: 'M',
          orderNumber: 1,
          betTypeId: 190,
          terminalShowType: BetTypeOutcomeShowType.BTOFullName,
          desktopShowType: BetTypeOutcomeShowType.BTOFullName,
          mobileShowType: BetTypeOutcomeShowType.BTOFullName,
          customName: '',
          descriptions: '',
        },
        {
          id: 758,
          name: 'Vise',
          shortName: 'V',
          orderNumber: 2,
          betTypeId: 190,
          terminalShowType: BetTypeOutcomeShowType.BTOFullName,
          desktopShowType: BetTypeOutcomeShowType.BTOFullName,
          mobileShowType: BetTypeOutcomeShowType.BTOFullName,
          customName: '',
          descriptions: '',
        }
      ],
    },
    // tenis
    {
      id: 5,
      betProductPageId: 3,
      sportId: 3,
      betTypeId: 186,
      hasSBV: false,
      betTypeName: 'Pobednik meca',
      sbvSelectionType: BetTypeSelectionSBVSelectionType.None,
      sbvExactValue: null,
      orderNumber: 1,
      isSelected: false,
      betTypeOutcomes: [
        {
          id: 746,
          name: '1',
          shortName: '1',
          orderNumber: 1,
          betTypeId: 186,
          terminalShowType: BetTypeOutcomeShowType.BTOFullName,
          desktopShowType: BetTypeOutcomeShowType.BTOFullName,
          mobileShowType: BetTypeOutcomeShowType.BTOFullName,
          customName: '',
          descriptions: '',
        },
        {
          id: 747,
          name: '1',
          shortName: '22',
          orderNumber: 2,
          betTypeId: 186,
          terminalShowType: BetTypeOutcomeShowType.BTOFullName,
          desktopShowType: BetTypeOutcomeShowType.BTOFullName,
          mobileShowType: BetTypeOutcomeShowType.BTOFullName,
          customName: '',
          descriptions: '',
        }
      ],
    },
    {
      id: 6,
      betProductPageId: 3,
      sportId: 3,
      betTypeId: 187,
      hasSBV: true,
      betTypeName: 'Ukupno gemova',
      sbvSelectionType: BetTypeSelectionSBVSelectionType.Exact,
      sbvExactValue: '20.5',
      orderNumber: 2,
      isSelected: false,
      betTypeOutcomes: [
        {
          id: 748,
          name: 'Manje',
          shortName: 'M',
          orderNumber: 1,
          betTypeId: 187,
          terminalShowType: BetTypeOutcomeShowType.BTOFullName,
          desktopShowType: BetTypeOutcomeShowType.BTOFullName,
          mobileShowType: BetTypeOutcomeShowType.BTOFullName,
          customName: '',
          descriptions: '',
        },
        {
          id: 749,
          name: 'Vise',
          shortName: 'V',
          orderNumber: 2,
          betTypeId: 187,
          terminalShowType: BetTypeOutcomeShowType.BTOFullName,
          desktopShowType: BetTypeOutcomeShowType.BTOFullName,
          mobileShowType: BetTypeOutcomeShowType.BTOFullName,
          customName: '',
          descriptions: '',
        }
      ],
    },
    // hokej
    {
      id: 7,
      betProductPageId: 3,
      sportId: 4,
      betTypeId: 135,
      hasSBV: false,
      betTypeName: 'Konacan ishod',
      sbvSelectionType: BetTypeSelectionSBVSelectionType.None,
      sbvExactValue: null,
      orderNumber: 1,
      isSelected: false,
      betTypeOutcomes: [
        {
          id: 424,
          name: '1',
          shortName: '1',
          orderNumber: 1,
          betTypeId: 135,
          terminalShowType: BetTypeOutcomeShowType.BTOShortName,
          desktopShowType: BetTypeOutcomeShowType.BTOShortName,
          mobileShowType: BetTypeOutcomeShowType.BTOShortName,
          customName: '',
          descriptions: '',
        },
        {
          id: 425,
          name: 'X',
          shortName: 'X',
          orderNumber: 2,
          betTypeId: 135,
          terminalShowType: BetTypeOutcomeShowType.BTOShortName,
          desktopShowType: BetTypeOutcomeShowType.BTOShortName,
          mobileShowType: BetTypeOutcomeShowType.BTOShortName,
          customName: '',
          descriptions: '',
        },
        {
          id: 426,
          name: '2',
          shortName: '2',
          orderNumber: 3,
          betTypeId: 135,
          terminalShowType: BetTypeOutcomeShowType.BTOShortName,
          desktopShowType: BetTypeOutcomeShowType.BTOShortName,
          mobileShowType: BetTypeOutcomeShowType.BTOShortName,
          customName: '',
          descriptions: '',
        }
      ],
    },
    {
      id: 8,
      betProductPageId: 3,
      sportId: 4,
      betTypeId: 137,
      hasSBV: true,
      betTypeName: 'Ukupno golova',
      sbvSelectionType: BetTypeSelectionSBVSelectionType.MostBalanced,
      sbvExactValue: '12.5',
      orderNumber: 2,
      isSelected: false,
      betTypeOutcomes: [
        {
          id: 429,
          name: 'Manje',
          shortName: 'M',
          orderNumber: 1,
          betTypeId: 137,
          terminalShowType: BetTypeOutcomeShowType.BTOFullName,
          desktopShowType: BetTypeOutcomeShowType.BTOFullName,
          mobileShowType: BetTypeOutcomeShowType.BTOFullName,
          customName: '',
          descriptions: '',
        },
        {
          id: 430,
          name: 'Vise',
          shortName: 'V',
          orderNumber: 2,
          betTypeId: 137,
          terminalShowType: BetTypeOutcomeShowType.BTOFullName,
          desktopShowType: BetTypeOutcomeShowType.BTOFullName,
          mobileShowType: BetTypeOutcomeShowType.BTOFullName,
          customName: '',
          descriptions: '',
        }
      ],
    },
    // bejzbol
    {
      id: 9,
      betProductPageId: 3,
      sportId: 5,
      betTypeId: 186,
      hasSBV: false,
      betTypeName: 'Pobednik meca',
      sbvSelectionType: BetTypeSelectionSBVSelectionType.None,
      sbvExactValue: null,
      orderNumber: 1,
      isSelected: false,
      betTypeOutcomes: [
        {
          id: 746,
          name: '1',
          shortName: '1',
          orderNumber: 1,
          betTypeId: 186,
          terminalShowType: BetTypeOutcomeShowType.BTOFullName,
          desktopShowType: BetTypeOutcomeShowType.BTOFullName,
          mobileShowType: BetTypeOutcomeShowType.BTOFullName,
          customName: '',
          descriptions: '',
        },
        {
          id: 747,
          name: '2',
          shortName: '22',
          orderNumber: 2,
          betTypeId: 186,
          terminalShowType: BetTypeOutcomeShowType.BTOFullName,
          desktopShowType: BetTypeOutcomeShowType.BTOFullName,
          mobileShowType: BetTypeOutcomeShowType.BTOFullName,
          customName: '',
          descriptions: '',
        },
      ],
    },
    {
      id: 10,
      betProductPageId: 3,
      sportId: 5,
      betTypeId: 189,
      hasSBV: false,
      betTypeName: 'Konacan ishod',
      sbvSelectionType: BetTypeSelectionSBVSelectionType.None,
      sbvExactValue: null,
      orderNumber: 2,
      isSelected: false,
      betTypeOutcomes: [
        {
          id: 754,
          name: '1',
          shortName: '1',
          orderNumber: 1,
          betTypeId: 189,
          terminalShowType: BetTypeOutcomeShowType.BTOShortName,
          desktopShowType: BetTypeOutcomeShowType.BTOShortName,
          mobileShowType: BetTypeOutcomeShowType.BTOShortName,
          customName: '',
          descriptions: '',
        },
        {
          id: 755,
          name: 'X',
          shortName: 'X',
          orderNumber: 2,
          betTypeId: 189,
          terminalShowType: BetTypeOutcomeShowType.BTOShortName,
          desktopShowType: BetTypeOutcomeShowType.BTOShortName,
          mobileShowType: BetTypeOutcomeShowType.BTOShortName,
          customName: '',
          descriptions: '',
        },
        {
          id: 756,
          name: '2',
          shortName: '2',
          orderNumber: 3,
          betTypeId: 189,
          terminalShowType: BetTypeOutcomeShowType.BTOShortName,
          desktopShowType: BetTypeOutcomeShowType.BTOShortName,
          mobileShowType: BetTypeOutcomeShowType.BTOShortName,
          customName: '',
          descriptions: '',
        }
      ],
    },
    {
      id: 11,
      betProductPageId: 3,
      sportId: 5,
      betTypeId: 190,
      hasSBV: true,
      betTypeName: 'Ukupno poena M',
      sbvSelectionType: BetTypeSelectionSBVSelectionType.MostBalanced,
      sbvExactValue: '41.5',
      orderNumber: 3,
      isSelected: false,
      betTypeOutcomes: [],
    },

    // rukomet
    {
      id: 12,
      betProductPageId: 3,
      sportId: 6,
      betTypeId: 135,
      hasSBV: false,
      betTypeName: 'Konacan ishod',
      sbvSelectionType: BetTypeSelectionSBVSelectionType.None,
      sbvExactValue: null,
      orderNumber: 1,
      isSelected: false,
      betTypeOutcomes: [
        {
          id: 424,
          name: '1',
          shortName: '1',
          orderNumber: 1,
          betTypeId: 135,
          terminalShowType: BetTypeOutcomeShowType.BTOShortName,
          desktopShowType: BetTypeOutcomeShowType.BTOShortName,
          mobileShowType: BetTypeOutcomeShowType.BTOShortName,
          customName: '',
          descriptions: '',
        },
        {
          id: 425,
          name: 'X',
          shortName: 'X',
          orderNumber: 2,
          betTypeId: 135,
          terminalShowType: BetTypeOutcomeShowType.BTOShortName,
          desktopShowType: BetTypeOutcomeShowType.BTOShortName,
          mobileShowType: BetTypeOutcomeShowType.BTOShortName,
          customName: '',
          descriptions: '',
        },
        {
          id: 426,
          name: '2',
          shortName: '2',
          orderNumber: 3,
          betTypeId: 135,
          terminalShowType: BetTypeOutcomeShowType.BTOShortName,
          desktopShowType: BetTypeOutcomeShowType.BTOShortName,
          mobileShowType: BetTypeOutcomeShowType.BTOShortName,
          customName: '',
          descriptions: '',
        }
      ],
    },
    {
      id: 13,
      betProductPageId: 3,
      sportId: 6,
      betTypeId: 190,
      hasSBV: true,
      betTypeName: 'Ukupno poena M',
      sbvSelectionType: BetTypeSelectionSBVSelectionType.MostBalanced,
      sbvExactValue: null,
      orderNumber: 2,
      isSelected: false,
      betTypeOutcomes: [
        {
          id: 757,
          name: 'Manje',
          shortName: 'M',
          orderNumber: 1,
          betTypeId: 190,
          terminalShowType: BetTypeOutcomeShowType.BTOFullName,
          desktopShowType: BetTypeOutcomeShowType.BTOFullName,
          mobileShowType: BetTypeOutcomeShowType.BTOFullName,
          customName: '',
          descriptions: '',
        },
        {
          id: 758,
          name: 'Vise',
          shortName: 'V',
          orderNumber: 2,
          betTypeId: 190,
          terminalShowType: BetTypeOutcomeShowType.BTOFullName,
          desktopShowType: BetTypeOutcomeShowType.BTOFullName,
          mobileShowType: BetTypeOutcomeShowType.BTOFullName,
          customName: '',
          descriptions: '',
        }
      ],
    },
    // floorbNone
    {
      id: 14,
      betProductPageId: 3,
      sportId: 7,
      betTypeId: 135,
      hasSBV: false,
      betTypeName: 'Konacan ishod',
      sbvSelectionType: BetTypeSelectionSBVSelectionType.None,
      sbvExactValue: null,
      orderNumber: 1,
      isSelected: false,
      betTypeOutcomes: [
        {
          id: 424,
          name: '1',
          shortName: '1',
          orderNumber: 1,
          betTypeId: 135,
          terminalShowType: BetTypeOutcomeShowType.BTOFullName,
          desktopShowType: BetTypeOutcomeShowType.BTOFullName,
          mobileShowType: BetTypeOutcomeShowType.BTOFullName,
          customName: '',
          descriptions: '',
        },
        {
          id: 425,
          name: 'X',
          shortName: 'X',
          orderNumber: 2,
          betTypeId: 135,
          terminalShowType: BetTypeOutcomeShowType.BTOFullName,
          desktopShowType: BetTypeOutcomeShowType.BTOFullName,
          mobileShowType: BetTypeOutcomeShowType.BTOFullName,
          customName: '',
          descriptions: '',
        },
        {
          id: 426,
          name: '2',
          shortName: '2',
          orderNumber: 3,
          betTypeId: 135,
          terminalShowType: BetTypeOutcomeShowType.BTOFullName,
          desktopShowType: BetTypeOutcomeShowType.BTOFullName,
          mobileShowType: BetTypeOutcomeShowType.BTOFullName,
          customName: '',
          descriptions: '',
        }
      ],
    },
    {
      id: 15,
      betProductPageId: 3,
      sportId: 7,
      betTypeId: 186,
      hasSBV: false,
      betTypeName: 'Pobednik meca',
      sbvSelectionType: BetTypeSelectionSBVSelectionType.MostBalanced,
      sbvExactValue: null,
      orderNumber: 2,
      isSelected: false,
      betTypeOutcomes: [
        {
          id: 746,
          name: '1',
          shortName: '1',
          orderNumber: 1,
          betTypeId: 186,
          terminalShowType: BetTypeOutcomeShowType.BTOFullName,
          desktopShowType: BetTypeOutcomeShowType.BTOFullName,
          mobileShowType: BetTypeOutcomeShowType.BTOFullName,
          customName: '',
          descriptions: '',
        },
        {
          id: 747,
          name: '2',
          shortName: '22',
          orderNumber: 2,
          betTypeId: 186,
          terminalShowType: BetTypeOutcomeShowType.BTOFullName,
          desktopShowType: BetTypeOutcomeShowType.BTOFullName,
          mobileShowType: BetTypeOutcomeShowType.BTOFullName,
          customName: '',
          descriptions: '',
        },
      ],
    },

    // stoni tenis
    {
      id: 16,
      betProductPageId: 3,
      sportId: 17,
      betTypeId: 186,
      hasSBV: false,
      betTypeName: 'Pobednik meca',
      sbvSelectionType: BetTypeSelectionSBVSelectionType.None,
      sbvExactValue: null,
      orderNumber: 1,
      isSelected: false,
      betTypeOutcomes: [
        {
          id: 746,
          name: '1',
          shortName: '1',
          orderNumber: 1,
          betTypeId: 186,
          terminalShowType: BetTypeOutcomeShowType.BTOFullName,
          desktopShowType: BetTypeOutcomeShowType.BTOFullName,
          mobileShowType: BetTypeOutcomeShowType.BTOFullName,
          customName: '',
          descriptions: '',
        },
        {
          id: 747,
          name: '2',
          shortName: '22',
          orderNumber: 2,
          betTypeId: 186,
          terminalShowType: BetTypeOutcomeShowType.BTOFullName,
          desktopShowType: BetTypeOutcomeShowType.BTOFullName,
          mobileShowType: BetTypeOutcomeShowType.BTOFullName,
          customName: '',
          descriptions: '',
        },
      ],
    },

    // MMA
    {
      id: 17,
      betProductPageId: 3,
      sportId: 36,
      betTypeId: 186,
      hasSBV: false,
      betTypeName: 'Pobednik meca',
      sbvSelectionType: BetTypeSelectionSBVSelectionType.MostBalanced,
      sbvExactValue: null,
      orderNumber: 2,
      isSelected: false,
      betTypeOutcomes: [
        {
          id: 746,
          name: '1',
          shortName: '1',
          orderNumber: 1,
          betTypeId: 186,
          terminalShowType: BetTypeOutcomeShowType.BTOFullName,
          desktopShowType: BetTypeOutcomeShowType.BTOFullName,
          mobileShowType: BetTypeOutcomeShowType.BTOFullName,
          customName: '',
          descriptions: '',
        },
        {
          id: 747,
          name: '2',
          shortName: '22',
          orderNumber: 2,
          betTypeId: 186,
          terminalShowType: BetTypeOutcomeShowType.BTOFullName,
          desktopShowType: BetTypeOutcomeShowType.BTOFullName,
          mobileShowType: BetTypeOutcomeShowType.BTOFullName,
          customName: '',
          descriptions: '',
        },
      ],
    },

    // odbojka
    {
      id: 18,
      betProductPageId: 3,
      sportId: 20,
      betTypeId: 186,
      hasSBV: false,
      betTypeName: 'Pobednik meca',
      sbvSelectionType: BetTypeSelectionSBVSelectionType.None,
      sbvExactValue: null,
      orderNumber: 1,
      isSelected: false,
      betTypeOutcomes: [
        {
          id: 746,
          name: '1',
          shortName: '1',
          orderNumber: 1,
          betTypeId: 186,
          terminalShowType: BetTypeOutcomeShowType.BTOFullName,
          desktopShowType: BetTypeOutcomeShowType.BTOFullName,
          mobileShowType: BetTypeOutcomeShowType.BTOFullName,
          customName: '',
          descriptions: '',
        },
        {
          id: 747,
          name: '2',
          shortName: '22',
          orderNumber: 2,
          betTypeId: 186,
          terminalShowType: BetTypeOutcomeShowType.BTOFullName,
          desktopShowType: BetTypeOutcomeShowType.BTOFullName,
          mobileShowType: BetTypeOutcomeShowType.BTOFullName,
          customName: '',
          descriptions: '',
        },
      ],
    },
    {
      id: 21,
      betProductPageId: 3,
      sportId: 20,
      betTypeId: 243,
      hasSBV: true,
      betTypeName: 'Ukupno poena M',
      sbvSelectionType: BetTypeSelectionSBVSelectionType.MostBalanced,
      sbvExactValue: '163.5',
      orderNumber: 2,
      isSelected: false,
      betTypeOutcomes: [
        {
          id: 909,
          name: 'Manje',
          shortName: 'M',
          orderNumber: 1,
          betTypeId: 243,
          terminalShowType: BetTypeOutcomeShowType.BTOFullName,
          desktopShowType: BetTypeOutcomeShowType.BTOFullName,
          mobileShowType: BetTypeOutcomeShowType.BTOFullName,
          customName: '',
          descriptions: '',
        },
        {
          id: 910,
          name: 'Vise',
          shortName: 'V',
          orderNumber: 2,
          betTypeId: 243,
          terminalShowType: BetTypeOutcomeShowType.BTOFullName,
          desktopShowType: BetTypeOutcomeShowType.BTOFullName,
          mobileShowType: BetTypeOutcomeShowType.BTOFullName,
          customName: '',
          descriptions: '',
        }
      ],
    },

  ],

  liveSportsWithSelections: [
    {
      id: 1,
      name: 'Fudbal',
      regions: [
        {
          sportId: 1,
          name: 'International Clubs',
          shortName: null,
          competitions: [
            {
              sportId: 1,
              regionId: 104,
              name: 'Club Friendlies',
              shortName: 'Club Frien',
              eventsCount: 1,
              events: [
                {
                  code: '275',
                  dateTime: '2020-05-06T08:45:00',
                  competitionId: 15045,
                  regionId: 104,
                  sportId: 1,
                  competitionName: 'Club Friendlies',
                  eventName: 'Sai Gon - Long An',
                  eventShortName: 'Sai Gon - Long An',
                  isLive: true,
                  bets: [
                    {
                      betTypeId: 56,
                      betTypeName: 'Konačan ishod',
                      sBV: null,
                      orderNo: 56,
                      sportId: 1,
                      regionId: 104,
                      competitionId: 15045,
                      eventId: 599790,
                      betOutcomes: [
                        {
                          betTypeId: 56,
                          betTypeOutcomeId: 173,
                          name: '1',
                          sBV: null,
                          odd: 2.2,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 1,
                          regionId: 104,
                          competitionId: 15045,
                          eventId: 599790,
                          betId: 50858183,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156099230,
                          description: ''

                        },
                        {
                          betTypeId: 56,
                          betTypeOutcomeId: 174,
                          name: 'X',
                          sBV: null,
                          odd: 3.25,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 1,
                          regionId: 104,
                          competitionId: 15045,
                          eventId: 599790,
                          betId: 50858183,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: true,
                          trueOdd: null,
                          id: 156099231,
                          description: ''

                        },
                        {
                          betTypeId: 56,
                          betTypeOutcomeId: 175,
                          name: '2',
                          sBV: null,
                          odd: 2.9,
                          orderNo: 3,
                          resultStatus: 11,
                          sportId: 1,
                          regionId: 104,
                          competitionId: 15045,
                          eventId: 599790,
                          betId: 50858183,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: true,
                          trueOdd: null,
                          id: 156099232,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: true,
                      cashBackEnabled: true,
                      id: 50858183,

                    },
                    {
                      betTypeId: 30,
                      betTypeName: 'Sledeći gol',
                      sBV: '2',
                      orderNo: 24,
                      sportId: 1,
                      regionId: 104,
                      competitionId: 15045,
                      eventId: 599790,
                      betOutcomes: [
                        {
                          betTypeId: 30,
                          betTypeOutcomeId: 103,
                          name: '1',
                          sBV: '2',
                          odd: 1.3,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 1,
                          regionId: 104,
                          competitionId: 15045,
                          eventId: 599790,
                          betId: 50858220,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: true,
                          trueOdd: null,
                          id: 156099310,
                          description: ''

                        },
                        {
                          betTypeId: 30,
                          betTypeOutcomeId: 104,
                          name: 'X',
                          sBV: '2',
                          odd: 7.7,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 1,
                          regionId: 104,
                          competitionId: 15045,
                          eventId: 599790,
                          betId: 50858220,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: true,
                          trueOdd: null,
                          id: 156099311,
                          description: ''

                        },
                        {
                          betTypeId: 30,
                          betTypeOutcomeId: 105,
                          name: '2',
                          sBV: '2',
                          odd: 4.6,
                          orderNo: 3,
                          resultStatus: 11,
                          sportId: 1,
                          regionId: 104,
                          competitionId: 15045,
                          eventId: 599790,
                          betId: 50858220,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: true,
                          trueOdd: null,
                          id: 156099312,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: true,
                      cashBackEnabled: true,
                      id: 50858220,

                    },
                    {
                      betTypeId: 30,
                      betTypeName: 'Sledeći gol',
                      sBV: '3',
                      orderNo: 24,
                      sportId: 1,
                      regionId: 104,
                      competitionId: 15045,
                      eventId: 599790,
                      betOutcomes: [
                        {
                          betTypeId: 30,
                          betTypeOutcomeId: 103,
                          name: '1',
                          sBV: '3',
                          odd: 1.7,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 1,
                          regionId: 104,
                          competitionId: 15045,
                          eventId: 599790,
                          betId: 50862576,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: true,
                          trueOdd: null,
                          id: 156111079,
                          description: ''

                        },
                        {
                          betTypeId: 30,
                          betTypeOutcomeId: 104,
                          name: 'X',
                          sBV: '3',
                          odd: 2.65,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 1,
                          regionId: 104,
                          competitionId: 15045,
                          eventId: 599790,
                          betId: 50862576,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: true,
                          trueOdd: null,
                          id: 156111080,
                          description: ''

                        },
                        {
                          betTypeId: 30,
                          betTypeOutcomeId: 105,
                          name: '2',
                          sBV: '3',
                          odd: 6.3,
                          orderNo: 3,
                          resultStatus: 11,
                          sportId: 1,
                          regionId: 104,
                          competitionId: 15045,
                          eventId: 599790,
                          betId: 50862576,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: true,
                          trueOdd: null,
                          id: 156111081,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: true,
                      cashBackEnabled: true,
                      id: 50862576,

                    },
                    {
                      betTypeId: 6,
                      betTypeName: 'Pobednik ostatka meča ',
                      sBV: '0-0',
                      orderNo: 18,
                      sportId: 1,
                      regionId: 104,
                      competitionId: 15045,
                      eventId: 599790,
                      betOutcomes: [
                        {
                          betTypeId: 6,
                          betTypeOutcomeId: 12,
                          name: '1',
                          sBV: '0-0',
                          odd: 1.4,
                          orderNo: 1,
                          resultStatus: 0,
                          sportId: 1,
                          regionId: 104,
                          competitionId: 15045,
                          eventId: 599790,
                          betId: 50858210,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: true,
                          trueOdd: null,
                          id: 156099287,
                          description: ''

                        },
                        {
                          betTypeId: 6,
                          betTypeOutcomeId: 16,
                          name: 'X',
                          sBV: '0-0',
                          odd: 3.9,
                          orderNo: 2,
                          resultStatus: 0,
                          sportId: 1,
                          regionId: 104,
                          competitionId: 15045,
                          eventId: 599790,
                          betId: 50858210,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: true,
                          trueOdd: null,
                          id: 156099288,
                          description: ''

                        },
                        {
                          betTypeId: 6,
                          betTypeOutcomeId: 17,
                          name: '2',
                          sBV: '0-0',
                          odd: 8.2,
                          orderNo: 3,
                          resultStatus: 0,
                          sportId: 1,
                          regionId: 104,
                          competitionId: 15045,
                          eventId: 599790,
                          betId: 50858210,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: true,
                          trueOdd: null,
                          id: 156099289,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: true,
                      id: 50858210,

                    },
                    {
                      betTypeId: 6,
                      betTypeName: 'Pobednik ostatka meča ',
                      sBV: '0-1',
                      orderNo: 18,
                      sportId: 1,
                      regionId: 104,
                      competitionId: 15045,
                      eventId: 599790,
                      betOutcomes: [
                        {
                          betTypeId: 6,
                          betTypeOutcomeId: 12,
                          name: '1',
                          sBV: '0-1',
                          odd: 1.32,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 1,
                          regionId: 104,
                          competitionId: 15045,
                          eventId: 599790,
                          betId: 50862573,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: true,
                          trueOdd: null,
                          id: 156111072,
                          description: ''

                        },
                        {
                          betTypeId: 6,
                          betTypeOutcomeId: 16,
                          name: 'X',
                          sBV: '0-1',
                          odd: 4.1,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 1,
                          regionId: 104,
                          competitionId: 15045,
                          eventId: 599790,
                          betId: 50862573,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: true,
                          trueOdd: null,
                          id: 156111073,
                          description: ''

                        },
                        {
                          betTypeId: 6,
                          betTypeOutcomeId: 17,
                          name: '2',
                          sBV: '0-1',
                          odd: 9.1,
                          orderNo: 3,
                          resultStatus: 11,
                          sportId: 1,
                          regionId: 104,
                          competitionId: 15045,
                          eventId: 599790,
                          betId: 50862573,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: true,
                          trueOdd: null,
                          id: 156111074,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: true,
                      cashBackEnabled: true,
                      id: 50862573,

                    },
                    {
                      betTypeId: 22,
                      betTypeName: 'Ukupno',
                      sBV: '1.5',
                      orderNo: 27,
                      sportId: 1,
                      regionId: 104,
                      competitionId: 15045,
                      eventId: 599790,
                      betOutcomes: [
                        {
                          betTypeId: 22,
                          betTypeOutcomeId: 36,
                          name: 'Manje',
                          sBV: '1.5',
                          odd: 7.7,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 1,
                          regionId: 104,
                          competitionId: 15045,
                          eventId: 599790,
                          betId: 50858187,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: true,
                          trueOdd: null,
                          id: 156099240,
                          description: ''

                        },
                        {
                          betTypeId: 22,
                          betTypeOutcomeId: 37,
                          name: 'Više',
                          sBV: '1.5',
                          odd: 1.02,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 1,
                          regionId: 104,
                          competitionId: 15045,
                          eventId: 599790,
                          betId: 50858187,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: true,
                          trueOdd: null,
                          id: 156099241,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: true,
                      cashBackEnabled: true,
                      id: 50858187,

                    },
                    {
                      betTypeId: 22,
                      betTypeName: 'Ukupno',
                      sBV: '2.5',
                      orderNo: 27,
                      sportId: 1,
                      regionId: 104,
                      competitionId: 15045,
                      eventId: 599790,
                      betOutcomes: [
                        {
                          betTypeId: 22,
                          betTypeOutcomeId: 36,
                          name: 'Manje',
                          sBV: '2.5',
                          odd: 2.65,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 1,
                          regionId: 104,
                          competitionId: 15045,
                          eventId: 599790,
                          betId: 50858188,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: true,
                          trueOdd: null,
                          id: 156099242,
                          description: ''

                        },
                        {
                          betTypeId: 22,
                          betTypeOutcomeId: 37,
                          name: 'Više',
                          sBV: '2.5',
                          odd: 1.38,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 1,
                          regionId: 104,
                          competitionId: 15045,
                          eventId: 599790,
                          betId: 50858188,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: true,
                          trueOdd: null,
                          id: 156099243,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: true,
                      cashBackEnabled: true,
                      id: 50858188,

                    },
                    {
                      betTypeId: 22,
                      betTypeName: 'Ukupno',
                      sBV: '3.5',
                      orderNo: 27,
                      sportId: 1,
                      regionId: 104,
                      competitionId: 15045,
                      eventId: 599790,
                      betOutcomes: [
                        {
                          betTypeId: 22,
                          betTypeOutcomeId: 36,
                          name: 'Manje',
                          sBV: '3.5',
                          odd: 1.52,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 1,
                          regionId: 104,
                          competitionId: 15045,
                          eventId: 599790,
                          betId: 50858189,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: true,
                          trueOdd: null,
                          id: 156099244,
                          description: ''

                        },
                        {
                          betTypeId: 22,
                          betTypeOutcomeId: 37,
                          name: 'Više',
                          sBV: '3.5',
                          odd: 2.25,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 1,
                          regionId: 104,
                          competitionId: 15045,
                          eventId: 599790,
                          betId: 50858189,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: true,
                          trueOdd: null,
                          id: 156099245,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: true,
                      cashBackEnabled: true,
                      id: 50858189,

                    },
                    {
                      betTypeId: 22,
                      betTypeName: 'Ukupno',
                      sBV: '4.5',
                      orderNo: 27,
                      sportId: 1,
                      regionId: 104,
                      competitionId: 15045,
                      eventId: 599790,
                      betOutcomes: [
                        {
                          betTypeId: 22,
                          betTypeOutcomeId: 36,
                          name: 'Manje',
                          sBV: '4.5',
                          odd: 1.15,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 1,
                          regionId: 104,
                          competitionId: 15045,
                          eventId: 599790,
                          betId: 50858190,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: true,
                          trueOdd: null,
                          id: 156099246,
                          description: ''

                        },
                        {
                          betTypeId: 22,
                          betTypeOutcomeId: 37,
                          name: 'Više',
                          sBV: '4.5',
                          odd: 4.4,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 1,
                          regionId: 104,
                          competitionId: 15045,
                          eventId: 599790,
                          betId: 50858190,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: true,
                          trueOdd: null,
                          id: 156099247,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: true,
                      cashBackEnabled: true,
                      id: 50858190,

                    },
                    {
                      betTypeId: 22,
                      betTypeName: 'Ukupno',
                      sBV: '5.5',
                      orderNo: 27,
                      sportId: 1,
                      regionId: 104,
                      competitionId: 15045,
                      eventId: 599790,
                      betOutcomes: [
                        {
                          betTypeId: 22,
                          betTypeOutcomeId: 36,
                          name: 'Manje',
                          sBV: '5.5',
                          odd: 1.0,
                          orderNo: 1,
                          resultStatus: 0,
                          sportId: 1,
                          regionId: 104,
                          competitionId: 15045,
                          eventId: 599790,
                          betId: 50858191,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: true,
                          trueOdd: null,
                          id: 156099248,
                          description: ''

                        },
                        {
                          betTypeId: 22,
                          betTypeOutcomeId: 37,
                          name: 'Više',
                          sBV: '5.5',
                          odd: 9.5,
                          orderNo: 2,
                          resultStatus: 0,
                          sportId: 1,
                          regionId: 104,
                          competitionId: 15045,
                          eventId: 599790,
                          betId: 50858191,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: true,
                          trueOdd: null,
                          id: 156099249,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: true,
                      id: 50858191,

                    },
                    {
                      betTypeId: 22,
                      betTypeName: 'Ukupno',
                      sBV: '6.5',
                      orderNo: 27,
                      sportId: 1,
                      regionId: 104,
                      competitionId: 15045,
                      eventId: 599790,
                      betOutcomes: [
                        {
                          betTypeId: 22,
                          betTypeOutcomeId: 36,
                          name: 'Manje',
                          sBV: '6.5',
                          odd: 1.0,
                          orderNo: 1,
                          resultStatus: 0,
                          sportId: 1,
                          regionId: 104,
                          competitionId: 15045,
                          eventId: 599790,
                          betId: 50858192,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: true,
                          trueOdd: null,
                          id: 156099250,
                          description: ''

                        },
                        {
                          betTypeId: 22,
                          betTypeOutcomeId: 37,
                          name: 'Više',
                          sBV: '6.5',
                          odd: 1.0,
                          orderNo: 2,
                          resultStatus: 0,
                          sportId: 1,
                          regionId: 104,
                          competitionId: 15045,
                          eventId: 599790,
                          betId: 50858192,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: true,
                          trueOdd: null,
                          id: 156099251,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: true,
                      id: 50858192,

                    },
                    {
                      betTypeId: 22,
                      betTypeName: 'Ukupno',
                      sBV: '7.5',
                      orderNo: 27,
                      sportId: 1,
                      regionId: 104,
                      competitionId: 15045,
                      eventId: 599790,
                      betOutcomes: [
                        {
                          betTypeId: 22,
                          betTypeOutcomeId: 36,
                          name: 'Manje',
                          sBV: '7.5',
                          odd: 1.0,
                          orderNo: 1,
                          resultStatus: 0,
                          sportId: 1,
                          regionId: 104,
                          competitionId: 15045,
                          eventId: 599790,
                          betId: 50858193,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: false,
                          cashBackEnabled: true,
                          trueOdd: null,
                          id: 156099252,
                          description: ''

                        },
                        {
                          betTypeId: 22,
                          betTypeOutcomeId: 37,
                          name: 'Više',
                          sBV: '7.5',
                          odd: 1.0,
                          orderNo: 2,
                          resultStatus: 0,
                          sportId: 1,
                          regionId: 104,
                          competitionId: 15045,
                          eventId: 599790,
                          betId: 50858193,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: false,
                          cashBackEnabled: true,
                          trueOdd: null,
                          id: 156099253,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: true,
                      id: 50858193,

                    },
                    {
                      betTypeId: 22,
                      betTypeName: 'Ukupno',
                      sBV: '8.5',
                      orderNo: 27,
                      sportId: 1,
                      regionId: 104,
                      competitionId: 15045,
                      eventId: 599790,
                      betOutcomes: [
                        {
                          betTypeId: 22,
                          betTypeOutcomeId: 36,
                          name: 'Manje',
                          sBV: '8.5',
                          odd: 1.0,
                          orderNo: 1,
                          resultStatus: 0,
                          sportId: 1,
                          regionId: 104,
                          competitionId: 15045,
                          eventId: 599790,
                          betId: 50862570,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: false,
                          cashBackEnabled: true,
                          trueOdd: null,
                          id: 156111065,
                          description: ''

                        },
                        {
                          betTypeId: 22,
                          betTypeOutcomeId: 37,
                          name: 'Više',
                          sBV: '8.5',
                          odd: 1.0,
                          orderNo: 2,
                          resultStatus: 0,
                          sportId: 1,
                          regionId: 104,
                          competitionId: 15045,
                          eventId: 599790,
                          betId: 50862570,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: false,
                          cashBackEnabled: true,
                          trueOdd: null,
                          id: 156111066,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: true,
                      id: 50862570,

                    }
                  ],
                  betsCount: 36,
                  playableBetsCount: 0,
                  homeTeam: 'Sai Gon',
                  awayTeam: 'Long An',
                  systemStatus: 1,
                  isInOffer: true,
                  isPlayable: true,
                  cashBackEnabled: false,
                  betRadarEventId: 22057351,
                  mappingTypeId: 1,
                  siblingStandardEventId: null,
                  eventTypeId: 1,
                  id: 599790,
                  orderNo: 0

                }
              ],
              id: 15045

            }
          ],
          eventsCount: 1,
          id: 104

        },
        {
          sportId: 1,
          name: 'Electronic Leagues',
          shortName: null,
          competitions: [
            {
              sportId: 1,
              regionId: 811,
              name: 'Liga Pro(2x6min.)',
              shortName: 'Liga Pro(2x6min)',
              eventsCount: 1,
              events: [
                {
                  code: '256',
                  dateTime: '2020-05-06T09:10:00',
                  competitionId: 14734,
                  regionId: 811,
                  sportId: 1,
                  competitionName: 'Liga Pro(2x6min.)',
                  eventName: 'Rub FC Kazan Fifa - PSG Shemyakin Onze Fifa',
                  eventShortName: 'Rub FC Kazan Fifa - PSG Shemyakin Onze Fifa',
                  isLive: true,
                  bets: [
                    {
                      betTypeId: 56,
                      betTypeName: 'Konačan ishod',
                      sBV: null,
                      orderNo: 56,
                      sportId: 1,
                      regionId: 811,
                      competitionId: 14734,
                      eventId: 599771,
                      betOutcomes: [
                        {
                          betTypeId: 56,
                          betTypeOutcomeId: 173,
                          name: '1',
                          sBV: null,
                          odd: 2.55,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 1,
                          regionId: 811,
                          competitionId: 14734,
                          eventId: 599771,
                          betId: 50862898,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156111789,
                          description: ''

                        },
                        {
                          betTypeId: 56,
                          betTypeOutcomeId: 174,
                          name: 'X',
                          sBV: null,
                          odd: 3.25,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 1,
                          regionId: 811,
                          competitionId: 14734,
                          eventId: 599771,
                          betId: 50862898,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: true,
                          trueOdd: null,
                          id: 156111790,
                          description: ''

                        },
                        {
                          betTypeId: 56,
                          betTypeOutcomeId: 175,
                          name: '2',
                          sBV: null,
                          odd: 2.65,
                          orderNo: 3,
                          resultStatus: 11,
                          sportId: 1,
                          regionId: 811,
                          competitionId: 14734,
                          eventId: 599771,
                          betId: 50862898,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: true,
                          trueOdd: null,
                          id: 156111791,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: true,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: true,
                      cashBackEnabled: true,
                      id: 50862898,

                    },
                    {
                      betTypeId: 30,
                      betTypeName: 'Sledeći gol',
                      sBV: '1',
                      orderNo: 24,
                      sportId: 1,
                      regionId: 811,
                      competitionId: 14734,
                      eventId: 599771,
                      betOutcomes: [
                        {
                          betTypeId: 30,
                          betTypeOutcomeId: 103,
                          name: '1',
                          sBV: '1',
                          odd: 2,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 1,
                          regionId: 811,
                          competitionId: 14734,
                          eventId: 599771,
                          betId: 50862893,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: true,
                          trueOdd: null,
                          id: 156111775,
                          description: ''

                        },
                        {
                          betTypeId: 30,
                          betTypeOutcomeId: 104,
                          name: 'X',
                          sBV: '1',
                          odd: 9.5,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 1,
                          regionId: 811,
                          competitionId: 14734,
                          eventId: 599771,
                          betId: 50862893,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: true,
                          trueOdd: null,
                          id: 156111776,
                          description: ''

                        },
                        {
                          betTypeId: 30,
                          betTypeOutcomeId: 105,
                          name: '2',
                          sBV: '1',
                          odd: 2.05,
                          orderNo: 3,
                          resultStatus: 11,
                          sportId: 1,
                          regionId: 811,
                          competitionId: 14734,
                          eventId: 599771,
                          betId: 50862893,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: true,
                          trueOdd: null,
                          id: 156111777,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: true,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: true,
                      cashBackEnabled: true,
                      id: 50862893,

                    },
                    {
                      betTypeId: 6,
                      betTypeName: 'Pobednik ostatka meča ',
                      sBV: '0:0',
                      orderNo: 18,
                      sportId: 1,
                      regionId: 811,
                      competitionId: 14734,
                      eventId: 599771,
                      betOutcomes: [
                        {
                          betTypeId: 6,
                          betTypeOutcomeId: 12,
                          name: '1',
                          sBV: '0:0',
                          odd: 2.55,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 1,
                          regionId: 811,
                          competitionId: 14734,
                          eventId: 599771,
                          betId: 50862888,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: true,
                          trueOdd: null,
                          id: 156111762,
                          description: ''

                        },
                        {
                          betTypeId: 6,
                          betTypeOutcomeId: 16,
                          name: 'X',
                          sBV: '0:0',
                          odd: 3.25,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 1,
                          regionId: 811,
                          competitionId: 14734,
                          eventId: 599771,
                          betId: 50862888,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: true,
                          trueOdd: null,
                          id: 156111763,
                          description: ''

                        },
                        {
                          betTypeId: 6,
                          betTypeOutcomeId: 17,
                          name: '2',
                          sBV: '0:0',
                          odd: 2.65,
                          orderNo: 3,
                          resultStatus: 11,
                          sportId: 1,
                          regionId: 811,
                          competitionId: 14734,
                          eventId: 599771,
                          betId: 50862888,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: true,
                          trueOdd: null,
                          id: 156111764,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: true,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: true,
                      cashBackEnabled: true,
                      id: 50862888,

                    },
                    {
                      betTypeId: 22,
                      betTypeName: 'Ukupno',
                      sBV: '3.5',
                      orderNo: 27,
                      sportId: 1,
                      regionId: 811,
                      competitionId: 14734,
                      eventId: 599771,
                      betOutcomes: [
                        {
                          betTypeId: 22,
                          betTypeOutcomeId: 37,
                          name: 'Više',
                          sBV: '3.5',
                          odd: 3.75,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 1,
                          regionId: 811,
                          competitionId: 14734,
                          eventId: 599771,
                          betId: 50862884,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: true,
                          trueOdd: null,
                          id: 156111754,
                          description: ''

                        },
                        {
                          betTypeId: 22,
                          betTypeOutcomeId: 36,
                          name: 'Manje',
                          sBV: '3.5',
                          odd: 1.22,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 1,
                          regionId: 811,
                          competitionId: 14734,
                          eventId: 599771,
                          betId: 50862884,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: true,
                          trueOdd: null,
                          id: 156111755,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: true,
                      cashBackEnabled: true,
                      id: 50862884,

                    },
                    {
                      betTypeId: 22,
                      betTypeName: 'Ukupno',
                      sBV: '2.5',
                      orderNo: 27,
                      sportId: 1,
                      regionId: 811,
                      competitionId: 14734,
                      eventId: 599771,
                      betOutcomes: [
                        {
                          betTypeId: 22,
                          betTypeOutcomeId: 37,
                          name: 'Više',
                          sBV: '2.5',
                          odd: 2.1,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 1,
                          regionId: 811,
                          competitionId: 14734,
                          eventId: 599771,
                          betId: 50862885,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: true,
                          trueOdd: null,
                          id: 156111756,
                          description: ''

                        },
                        {
                          betTypeId: 22,
                          betTypeOutcomeId: 36,
                          name: 'Manje',
                          sBV: '2.5',
                          odd: 1.65,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 1,
                          regionId: 811,
                          competitionId: 14734,
                          eventId: 599771,
                          betId: 50862885,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: true,
                          trueOdd: null,
                          id: 156111757,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: true,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: true,
                      cashBackEnabled: true,
                      id: 50862885,

                    },
                    {
                      betTypeId: 22,
                      betTypeName: 'Ukupno',
                      sBV: '1.5',
                      orderNo: 27,
                      sportId: 1,
                      regionId: 811,
                      competitionId: 14734,
                      eventId: 599771,
                      betOutcomes: [
                        {
                          betTypeId: 22,
                          betTypeOutcomeId: 37,
                          name: 'Više',
                          sBV: '1.5',
                          odd: 1.37,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 1,
                          regionId: 811,
                          competitionId: 14734,
                          eventId: 599771,
                          betId: 50862887,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: true,
                          trueOdd: null,
                          id: 156111760,
                          description: ''

                        },
                        {
                          betTypeId: 22,
                          betTypeOutcomeId: 36,
                          name: 'Manje',
                          sBV: '1.5',
                          odd: 2.9,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 1,
                          regionId: 811,
                          competitionId: 14734,
                          eventId: 599771,
                          betId: 50862887,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: true,
                          trueOdd: null,
                          id: 156111761,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: true,
                      cashBackEnabled: true,
                      id: 50862887,

                    }
                  ],
                  betsCount: 31,
                  playableBetsCount: 0,
                  homeTeam: 'Rub FC Kazan Fifa',
                  awayTeam: 'PSG Shemyakin Onze Fifa',
                  systemStatus: 1,
                  isInOffer: true,
                  isPlayable: true,
                  cashBackEnabled: true,
                  betRadarEventId: 22059515,
                  mappingTypeId: 1,
                  siblingStandardEventId: null,
                  eventTypeId: 1,
                  id: 599771,
                  orderNo: 0

                }
              ],
              id: 14734

            }
          ],
          eventsCount: 1,
          id: 811

        }
      ],
      eventsCount: 2,
      selections: [
        {
          id: 34,
          betProductPageId: 5,
          sportId: 1,
          betTypeId: 56,
          hasSBV: false,
          betTypeName: 'Konačan ishod',
          sBVSelectionType: null,
          sBVExactValue: null,
          orderNumber: 1,
        },
        {
          id: 37,
          betProductPageId: 5,
          sportId: 1,
          betTypeId: 30,
          betTypeName: 'Sledeći gol',
          hasSBV: true,
          orderNumber: 2,
          sBVSelectionType: 1,
          sBVExactValue: null
        },
        {
          id: 36,
          betProductPageId: 5,
          sportId: 1,
          betTypeId: 6,
          betTypeName: 'Pobednik ostatka meča ',
          hasSBV: true,
          orderNumber: 3,
          sBVSelectionType: 1,
          sBVExactValue: null
        },
        {
          id: 35,
          betProductPageId: 5,
          sportId: 1,
          betTypeId: 22,
          betTypeName: 'Ukupno',
          hasSBV: true,
          orderNumber: 4,
          sBVSelectionType: 1,
          sBVExactValue: null
        }
      ]
    },
    {
      id: 17,
      name: 'Stoni tenis',
      regions: [
        {
          sportId: 17,
          name: 'International',
          shortName: null,
          competitions: [
            {
              sportId: 17,
              regionId: 258,
              name: 'Tt Cup',
              shortName: 'Tt Cup',
              eventsCount: 2,
              events: [
                {
                  code: '709',
                  dateTime: '2020-05-06T09:10:00',
                  competitionId: 14329,
                  regionId: 258,
                  sportId: 17,
                  competitionName: 'Tt Cup',
                  eventName: 'Rybachuk, Roman - Berezynskyi, Serhii',
                  eventShortName: 'Rybachuk, Roman - Berezynskyi, Serhii',
                  isLive: true,
                  bets: [
                    {
                      betTypeId: 86,
                      betTypeName: 'Pobednik ',
                      sBV: null,
                      orderNo: 86,
                      sportId: 17,
                      regionId: 258,
                      competitionId: 14329,
                      eventId: 599254,
                      betOutcomes: [
                        {
                          betTypeId: 86,
                          betTypeOutcomeId: 238,
                          name: '1',
                          sBV: null,
                          odd: 1.22,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14329,
                          eventId: 599254,
                          betId: 50780844,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 155892291,
                          description: ''

                        },
                        {
                          betTypeId: 86,
                          betTypeOutcomeId: 239,
                          name: '2',
                          sBV: null,
                          odd: 3.7,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14329,
                          eventId: 599254,
                          betId: 50780844,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 155892292,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: true,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: true,
                      cashBackEnabled: null,
                      id: 50780844,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '78.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 258,
                      competitionId: 14329,
                      eventId: 599254,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '78.5',
                          odd: 1.9,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14329,
                          eventId: 599254,
                          betId: 50862464,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156110846,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '78.5',
                          odd: 1.8,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14329,
                          eventId: 599254,
                          betId: 50862464,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156110847,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50862464,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '79.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 258,
                      competitionId: 14329,
                      eventId: 599254,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '79.5',
                          odd: 1.85,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14329,
                          eventId: 599254,
                          betId: 50862484,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156110886,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '79.5',
                          odd: 1.8,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14329,
                          eventId: 599254,
                          betId: 50862484,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156110887,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50862484,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '77.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 258,
                      competitionId: 14329,
                      eventId: 599254,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '77.5',
                          odd: 1.85,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14329,
                          eventId: 599254,
                          betId: 50862653,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156111243,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '77.5',
                          odd: 1.8,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14329,
                          eventId: 599254,
                          betId: 50862653,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156111244,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50862653,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '76.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 258,
                      competitionId: 14329,
                      eventId: 599254,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '76.5',
                          odd: 1.85,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14329,
                          eventId: 599254,
                          betId: 50862674,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156111287,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '76.5',
                          odd: 1.8,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14329,
                          eventId: 599254,
                          betId: 50862674,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156111288,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50862674,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '80.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 258,
                      competitionId: 14329,
                      eventId: 599254,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '80.5',
                          odd: 1.85,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14329,
                          eventId: 599254,
                          betId: 50862752,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156111469,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '80.5',
                          odd: 1.8,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14329,
                          eventId: 599254,
                          betId: 50862752,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156111470,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50862752,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '75.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 258,
                      competitionId: 14329,
                      eventId: 599254,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '75.5',
                          odd: 1.85,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14329,
                          eventId: 599254,
                          betId: 50863063,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156112153,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '75.5',
                          odd: 1.85,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14329,
                          eventId: 599254,
                          betId: 50863063,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156112154,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50863063,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '73.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 258,
                      competitionId: 14329,
                      eventId: 599254,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '73.5',
                          odd: 1.85,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14329,
                          eventId: 599254,
                          betId: 50863094,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156112218,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '73.5',
                          odd: 1.85,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14329,
                          eventId: 599254,
                          betId: 50863094,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156112219,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: true,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: true,
                      cashBackEnabled: false,
                      id: 50863094,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '69.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 258,
                      competitionId: 14329,
                      eventId: 599254,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '69.5',
                          odd: 1.85,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14329,
                          eventId: 599254,
                          betId: 50863286,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156112651,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '69.5',
                          odd: 1.85,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14329,
                          eventId: 599254,
                          betId: 50863286,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156112652,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50863286,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '81.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 258,
                      competitionId: 14329,
                      eventId: 599254,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '81.5',
                          odd: 1.85,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14329,
                          eventId: 599254,
                          betId: 50863351,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156112809,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '81.5',
                          odd: 1.85,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14329,
                          eventId: 599254,
                          betId: 50863351,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156112810,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50863351,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '82.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 258,
                      competitionId: 14329,
                      eventId: 599254,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '82.5',
                          odd: 1.85,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14329,
                          eventId: 599254,
                          betId: 50863352,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156112811,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '82.5',
                          odd: 1.8,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14329,
                          eventId: 599254,
                          betId: 50863352,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156112812,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50863352,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '84.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 258,
                      competitionId: 14329,
                      eventId: 599254,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '84.5',
                          odd: 1.85,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14329,
                          eventId: 599254,
                          betId: 50863401,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156112939,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '84.5',
                          odd: 1.8,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14329,
                          eventId: 599254,
                          betId: 50863401,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156112940,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50863401,

                    },
                    {
                      betTypeId: 385,
                      betTypeName: 'Broj gemova (5g)',
                      sBV: null,
                      orderNo: 385,
                      sportId: 17,
                      regionId: 258,
                      competitionId: 14329,
                      eventId: 599254,
                      betOutcomes: [
                        {
                          betTypeId: 385,
                          betTypeOutcomeId: 1328,
                          name: '3',
                          sBV: null,
                          odd: 2.05,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14329,
                          eventId: 599254,
                          betId: 50780880,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 155892367,
                          description: ''

                        },
                        {
                          betTypeId: 385,
                          betTypeOutcomeId: 1329,
                          name: '4',
                          sBV: null,
                          odd: 4.05,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14329,
                          eventId: 599254,
                          betId: 50780880,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 155892368,
                          description: ''

                        },
                        {
                          betTypeId: 385,
                          betTypeOutcomeId: 1330,
                          name: '5',
                          sBV: null,
                          odd: 2.45,
                          orderNo: 3,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14329,
                          eventId: 599254,
                          betId: 50780880,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 155892369,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: true,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: true,
                      cashBackEnabled: null,
                      id: 50780880,

                    }
                  ],
                  betsCount: 16,
                  playableBetsCount: 0,
                  homeTeam: 'Rybachuk, Roman',
                  awayTeam: 'Berezynskyi, Serhii',
                  systemStatus: 1,
                  isInOffer: true,
                  isPlayable: true,
                  cashBackEnabled: true,
                  betRadarEventId: 21962385,
                  mappingTypeId: 1,
                  siblingStandardEventId: null,
                  eventTypeId: 1,
                  id: 599254,
                  orderNo: 0

                },
                {
                  code: '742',
                  dateTime: '2020-05-06T09:15:00',
                  competitionId: 14329,
                  regionId: 258,
                  sportId: 17,
                  competitionName: 'Tt Cup',
                  eventName: 'Ivanov, Leonid - Hladun, Valerii',
                  eventShortName: 'Ivanov, Leonid - Hladun, Valerii',
                  isLive: true,
                  bets: [
                    {
                      betTypeId: 86,
                      betTypeName: 'Pobednik ',
                      sBV: null,
                      orderNo: 86,
                      sportId: 17,
                      regionId: 258,
                      competitionId: 14329,
                      eventId: 599287,
                      betOutcomes: [
                        {
                          betTypeId: 86,
                          betTypeOutcomeId: 238,
                          name: '1',
                          sBV: null,
                          odd: 1.45,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14329,
                          eventId: 599287,
                          betId: 50783033,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 155896905,
                          description: ''

                        },
                        {
                          betTypeId: 86,
                          betTypeOutcomeId: 239,
                          name: '2',
                          sBV: null,
                          odd: 2.55,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14329,
                          eventId: 599287,
                          betId: 50783033,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 155896906,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: true,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: true,
                      cashBackEnabled: null,
                      id: 50783033,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '76.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 258,
                      competitionId: 14329,
                      eventId: 599287,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '76.5',
                          odd: 1.85,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14329,
                          eventId: 599287,
                          betId: 50862590,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156111108,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '76.5',
                          odd: 1.8,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14329,
                          eventId: 599287,
                          betId: 50862590,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156111109,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50862590,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '77.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 258,
                      competitionId: 14329,
                      eventId: 599287,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '77.5',
                          odd: 1.85,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14329,
                          eventId: 599287,
                          betId: 50862696,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156111335,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '77.5',
                          odd: 1.8,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14329,
                          eventId: 599287,
                          betId: 50862696,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156111336,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50862696,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '78.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 258,
                      competitionId: 14329,
                      eventId: 599287,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '78.5',
                          odd: 1.85,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14329,
                          eventId: 599287,
                          betId: 50862845,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156111673,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '78.5',
                          odd: 1.8,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14329,
                          eventId: 599287,
                          betId: 50862845,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156111674,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50862845,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '79.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 258,
                      competitionId: 14329,
                      eventId: 599287,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '79.5',
                          odd: 1.85,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14329,
                          eventId: 599287,
                          betId: 50862979,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156111979,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '79.5',
                          odd: 1.85,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14329,
                          eventId: 599287,
                          betId: 50862979,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156111980,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50862979,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '80.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 258,
                      competitionId: 14329,
                      eventId: 599287,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '80.5',
                          odd: 1.85,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14329,
                          eventId: 599287,
                          betId: 50863283,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156112645,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '80.5',
                          odd: 1.85,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14329,
                          eventId: 599287,
                          betId: 50863283,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156112646,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: true,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: true,
                      cashBackEnabled: false,
                      id: 50863283,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '81.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 258,
                      competitionId: 14329,
                      eventId: 599287,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '81.5',
                          odd: 1.85,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14329,
                          eventId: 599287,
                          betId: 50863509,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156113195,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '81.5',
                          odd: 1.85,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14329,
                          eventId: 599287,
                          betId: 50863509,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156113196,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50863509,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '82.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 258,
                      competitionId: 14329,
                      eventId: 599287,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '82.5',
                          odd: 1.9,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14329,
                          eventId: 599287,
                          betId: 50863563,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156113327,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '82.5',
                          odd: 1.8,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14329,
                          eventId: 599287,
                          betId: 50863563,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156113328,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50863563,

                    },
                    {
                      betTypeId: 385,
                      betTypeName: 'Broj gemova (5g)',
                      sBV: null,
                      orderNo: 385,
                      sportId: 17,
                      regionId: 258,
                      competitionId: 14329,
                      eventId: 599287,
                      betOutcomes: [
                        {
                          betTypeId: 385,
                          betTypeOutcomeId: 1329,
                          name: '4',
                          sBV: null,
                          odd: 1.65,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14329,
                          eventId: 599287,
                          betId: 50783088,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 155897020,
                          description: ''

                        },
                        {
                          betTypeId: 385,
                          betTypeOutcomeId: 1330,
                          name: '5',
                          sBV: null,
                          odd: 2,
                          orderNo: 3,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14329,
                          eventId: 599287,
                          betId: 50783088,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 155897022,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: true,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: true,
                      cashBackEnabled: null,
                      id: 50783088,

                    }
                  ],
                  betsCount: 20,
                  playableBetsCount: 0,
                  homeTeam: 'Ivanov, Leonid',
                  awayTeam: 'Hladun, Valerii',
                  systemStatus: 1,
                  isInOffer: true,
                  isPlayable: true,
                  cashBackEnabled: true,
                  betRadarEventId: null,
                  mappingTypeId: 1,
                  siblingStandardEventId: null,
                  eventTypeId: 1,
                  id: 599287,
                  orderNo: 0

                }
              ],
              id: 14329

            },
            {
              sportId: 17,
              regionId: 258,
              name: 'Setka Cup',
              shortName: 'UKR Setka Cup',
              eventsCount: 1,
              events: [
                {
                  code: '747',
                  dateTime: '2020-05-06T09:15:00',
                  competitionId: 14659,
                  regionId: 258,
                  sportId: 17,
                  competitionName: 'Setka Cup',
                  eventName: 'Troian, Andrii - Dynaburg, Leonid',
                  eventShortName: 'Troian, Andrii - Dynaburg, Leonid',
                  isLive: true,
                  bets: [
                    {
                      betTypeId: 86,
                      betTypeName: 'Pobednik ',
                      sBV: null,
                      orderNo: 86,
                      sportId: 17,
                      regionId: 258,
                      competitionId: 14659,
                      eventId: 599292,
                      betOutcomes: [
                        {
                          betTypeId: 86,
                          betTypeOutcomeId: 238,
                          name: '1',
                          sBV: null,
                          odd: 1.9,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14659,
                          eventId: 599292,
                          betId: 50783390,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 155897657,
                          description: ''

                        },
                        {
                          betTypeId: 86,
                          betTypeOutcomeId: 239,
                          name: '2',
                          sBV: null,
                          odd: 1.8,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14659,
                          eventId: 599292,
                          betId: 50783390,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 155897658,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: true,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: true,
                      cashBackEnabled: null,
                      id: 50783390,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '76.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 258,
                      competitionId: 14659,
                      eventId: 599292,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '76.5',
                          odd: 1.95,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14659,
                          eventId: 599292,
                          betId: 50862132,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156109964,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '76.5',
                          odd: 1.75,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14659,
                          eventId: 599292,
                          betId: 50862132,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156109965,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50862132,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '77.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 258,
                      competitionId: 14659,
                      eventId: 599292,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '77.5',
                          odd: 1.85,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14659,
                          eventId: 599292,
                          betId: 50862878,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156111741,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '77.5',
                          odd: 1.8,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14659,
                          eventId: 599292,
                          betId: 50862878,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156111742,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50862878,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '75.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 258,
                      competitionId: 14659,
                      eventId: 599292,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '75.5',
                          odd: 1.9,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14659,
                          eventId: 599292,
                          betId: 50862952,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156111903,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '75.5',
                          odd: 1.75,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14659,
                          eventId: 599292,
                          betId: 50862952,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156111904,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50862952,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '74.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 258,
                      competitionId: 14659,
                      eventId: 599292,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '74.5',
                          odd: 1.9,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14659,
                          eventId: 599292,
                          betId: 50862954,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156111907,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '74.5',
                          odd: 1.75,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14659,
                          eventId: 599292,
                          betId: 50862954,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156111908,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50862954,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '73.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 258,
                      competitionId: 14659,
                      eventId: 599292,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '73.5',
                          odd: 1.85,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14659,
                          eventId: 599292,
                          betId: 50862960,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156111919,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '73.5',
                          odd: 1.85,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14659,
                          eventId: 599292,
                          betId: 50862960,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156111920,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50862960,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '72.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 258,
                      competitionId: 14659,
                      eventId: 599292,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '72.5',
                          odd: 1.9,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14659,
                          eventId: 599292,
                          betId: 50862962,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156111923,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '72.5',
                          odd: 1.75,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14659,
                          eventId: 599292,
                          betId: 50862962,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156111924,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50862962,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '71.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 258,
                      competitionId: 14659,
                      eventId: 599292,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '71.5',
                          odd: 1.85,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14659,
                          eventId: 599292,
                          betId: 50863038,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156112101,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '71.5',
                          odd: 1.8,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14659,
                          eventId: 599292,
                          betId: 50863038,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156112102,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50863038,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '69.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 258,
                      competitionId: 14659,
                      eventId: 599292,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '69.5',
                          odd: 1.85,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14659,
                          eventId: 599292,
                          betId: 50863133,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156112310,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '69.5',
                          odd: 1.85,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14659,
                          eventId: 599292,
                          betId: 50863133,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156112311,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50863133,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '78.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 258,
                      competitionId: 14659,
                      eventId: 599292,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '78.5',
                          odd: 1.9,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14659,
                          eventId: 599292,
                          betId: 50863355,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156112817,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '78.5',
                          odd: 1.75,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14659,
                          eventId: 599292,
                          betId: 50863355,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156112818,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50863355,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '80.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 258,
                      competitionId: 14659,
                      eventId: 599292,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '80.5',
                          odd: 1.85,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14659,
                          eventId: 599292,
                          betId: 50863488,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156113143,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '80.5',
                          odd: 1.85,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14659,
                          eventId: 599292,
                          betId: 50863488,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156113144,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50863488,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '81.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 258,
                      competitionId: 14659,
                      eventId: 599292,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '81.5',
                          odd: 1.9,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14659,
                          eventId: 599292,
                          betId: 50863491,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156113149,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '81.5',
                          odd: 1.75,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14659,
                          eventId: 599292,
                          betId: 50863491,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156113150,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50863491,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '83.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 258,
                      competitionId: 14659,
                      eventId: 599292,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '83.5',
                          odd: 1.85,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14659,
                          eventId: 599292,
                          betId: 50863517,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156113211,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '83.5',
                          odd: 1.8,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14659,
                          eventId: 599292,
                          betId: 50863517,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156113212,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: true,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: true,
                      cashBackEnabled: false,
                      id: 50863517,

                    },
                    {
                      betTypeId: 385,
                      betTypeName: 'Broj gemova (5g)',
                      sBV: null,
                      orderNo: 385,
                      sportId: 17,
                      regionId: 258,
                      competitionId: 14659,
                      eventId: 599292,
                      betOutcomes: [
                        {
                          betTypeId: 385,
                          betTypeOutcomeId: 1329,
                          name: '4',
                          sBV: null,
                          odd: 1.75,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14659,
                          eventId: 599292,
                          betId: 50783426,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 155897734,
                          description: ''

                        },
                        {
                          betTypeId: 385,
                          betTypeOutcomeId: 1330,
                          name: '5',
                          sBV: null,
                          odd: 1.9,
                          orderNo: 3,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 14659,
                          eventId: 599292,
                          betId: 50783426,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 155897735,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: true,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: true,
                      cashBackEnabled: null,
                      id: 50783426,

                    }
                  ],
                  betsCount: 20,
                  playableBetsCount: 0,
                  homeTeam: 'Troian, Andrii',
                  awayTeam: 'Dynaburg, Leonid',
                  systemStatus: 1,
                  isInOffer: true,
                  isPlayable: true,
                  cashBackEnabled: true,
                  betRadarEventId: 21960363,
                  mappingTypeId: 1,
                  siblingStandardEventId: null,
                  eventTypeId: 1,
                  id: 599292,
                  orderNo: 0

                }
              ],
              id: 14659

            },
            {
              sportId: 17,
              regionId: 258,
              name: 'Ukraine Win Cup',
              shortName: 'UKR Win Cup',
              eventsCount: 1,
              events: [
                {
                  code: '725',
                  dateTime: '2020-05-06T09:00:00',
                  competitionId: 15171,
                  regionId: 258,
                  sportId: 17,
                  competitionName: 'Ukraine Win Cup',
                  eventName: 'Rodin, Aleksey - Akimov, Igor',
                  eventShortName: 'Rodin, Aleksey - Akimov, Igor',
                  isLive: true,
                  bets: [
                    {
                      betTypeId: 86,
                      betTypeName: 'Pobednik ',
                      sBV: null,
                      orderNo: 86,
                      sportId: 17,
                      regionId: 258,
                      competitionId: 15171,
                      eventId: 599270,
                      betOutcomes: [
                        {
                          betTypeId: 86,
                          betTypeOutcomeId: 238,
                          name: '1',
                          sBV: null,
                          odd: 1.27,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 15171,
                          eventId: 599270,
                          betId: 50781895,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 155894510,
                          description: ''

                        },
                        {
                          betTypeId: 86,
                          betTypeOutcomeId: 239,
                          name: '2',
                          sBV: null,
                          odd: 3.3,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 15171,
                          eventId: 599270,
                          betId: 50781895,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 155894511,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: true,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: true,
                      cashBackEnabled: null,
                      id: 50781895,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '76.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 258,
                      competitionId: 15171,
                      eventId: 599270,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '76.5',
                          odd: 1.85,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 15171,
                          eventId: 599270,
                          betId: 50860275,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156103897,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '76.5',
                          odd: 1.85,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 15171,
                          eventId: 599270,
                          betId: 50860275,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156103898,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50860275,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '77.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 258,
                      competitionId: 15171,
                      eventId: 599270,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '77.5',
                          odd: 1.95,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 15171,
                          eventId: 599270,
                          betId: 50860429,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156104246,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '77.5',
                          odd: 1.75,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 15171,
                          eventId: 599270,
                          betId: 50860429,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156104247,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50860429,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '75.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 258,
                      competitionId: 15171,
                      eventId: 599270,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '75.5',
                          odd: 1.85,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 15171,
                          eventId: 599270,
                          betId: 50861014,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156106334,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '75.5',
                          odd: 1.85,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 15171,
                          eventId: 599270,
                          betId: 50861014,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156106335,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: true,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: true,
                      cashBackEnabled: false,
                      id: 50861014,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '73.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 258,
                      competitionId: 15171,
                      eventId: 599270,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '73.5',
                          odd: 1.85,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 15171,
                          eventId: 599270,
                          betId: 50861047,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156106408,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '73.5',
                          odd: 1.8,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 15171,
                          eventId: 599270,
                          betId: 50861047,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156106409,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50861047,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '74.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 258,
                      competitionId: 15171,
                      eventId: 599270,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '74.5',
                          odd: 1.9,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 15171,
                          eventId: 599270,
                          betId: 50861161,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156106659,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '74.5',
                          odd: 1.8,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 15171,
                          eventId: 599270,
                          betId: 50861161,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156106660,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50861161,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '79.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 258,
                      competitionId: 15171,
                      eventId: 599270,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '79.5',
                          odd: 1.85,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 15171,
                          eventId: 599270,
                          betId: 50862401,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156110701,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '79.5',
                          odd: 1.8,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 15171,
                          eventId: 599270,
                          betId: 50862401,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156110702,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50862401,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '78.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 258,
                      competitionId: 15171,
                      eventId: 599270,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '78.5',
                          odd: 1.9,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 15171,
                          eventId: 599270,
                          betId: 50862542,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156111005,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '78.5',
                          odd: 1.8,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 15171,
                          eventId: 599270,
                          betId: 50862542,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156111006,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50862542,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '81.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 258,
                      competitionId: 15171,
                      eventId: 599270,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '81.5',
                          odd: 1.85,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 15171,
                          eventId: 599270,
                          betId: 50862669,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156111277,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '81.5',
                          odd: 1.85,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 15171,
                          eventId: 599270,
                          betId: 50862669,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156111278,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50862669,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '80.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 258,
                      competitionId: 15171,
                      eventId: 599270,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '80.5',
                          odd: 1.85,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 15171,
                          eventId: 599270,
                          betId: 50862695,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156111333,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '80.5',
                          odd: 1.8,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 15171,
                          eventId: 599270,
                          betId: 50862695,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156111334,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50862695,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '65.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 258,
                      competitionId: 15171,
                      eventId: 599270,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '65.5',
                          odd: 1.85,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 15171,
                          eventId: 599270,
                          betId: 50862791,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156111565,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '65.5',
                          odd: 1.85,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 15171,
                          eventId: 599270,
                          betId: 50862791,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156111566,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50862791,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '72.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 258,
                      competitionId: 15171,
                      eventId: 599270,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '72.5',
                          odd: 1.9,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 15171,
                          eventId: 599270,
                          betId: 50862814,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156111611,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '72.5',
                          odd: 1.8,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 15171,
                          eventId: 599270,
                          betId: 50862814,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156111612,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50862814,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '70.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 258,
                      competitionId: 15171,
                      eventId: 599270,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '70.5',
                          odd: 1.85,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 15171,
                          eventId: 599270,
                          betId: 50862816,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156111615,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '70.5',
                          odd: 1.85,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 15171,
                          eventId: 599270,
                          betId: 50862816,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156111616,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50862816,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '71.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 258,
                      competitionId: 15171,
                      eventId: 599270,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '71.5',
                          odd: 1.85,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 15171,
                          eventId: 599270,
                          betId: 50862876,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156111737,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '71.5',
                          odd: 1.8,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 15171,
                          eventId: 599270,
                          betId: 50862876,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156111738,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50862876,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '69.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 258,
                      competitionId: 15171,
                      eventId: 599270,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '69.5',
                          odd: 1.85,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 15171,
                          eventId: 599270,
                          betId: 50862904,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156111802,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '69.5',
                          odd: 1.85,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 15171,
                          eventId: 599270,
                          betId: 50862904,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156111803,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50862904,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '61.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 258,
                      competitionId: 15171,
                      eventId: 599270,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '61.5',
                          odd: 1.95,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 15171,
                          eventId: 599270,
                          betId: 50863040,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156112105,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '61.5',
                          odd: 1.7,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 15171,
                          eventId: 599270,
                          betId: 50863040,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156112106,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50863040,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '85.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 258,
                      competitionId: 15171,
                      eventId: 599270,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '85.5',
                          odd: 1.9,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 15171,
                          eventId: 599270,
                          betId: 50863279,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156112631,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '85.5',
                          odd: 1.8,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 15171,
                          eventId: 599270,
                          betId: 50863279,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156112632,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50863279,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '83.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 258,
                      competitionId: 15171,
                      eventId: 599270,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '83.5',
                          odd: 1.85,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 15171,
                          eventId: 599270,
                          betId: 50863295,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156112669,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '83.5',
                          odd: 1.85,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 15171,
                          eventId: 599270,
                          betId: 50863295,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156112670,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50863295,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '86.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 258,
                      competitionId: 15171,
                      eventId: 599270,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '86.5',
                          odd: 1.9,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 15171,
                          eventId: 599270,
                          betId: 50863333,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156112773,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '86.5',
                          odd: 1.75,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 15171,
                          eventId: 599270,
                          betId: 50863333,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156112774,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50863333,

                    },
                    {
                      betTypeId: 385,
                      betTypeName: 'Broj gemova (5g)',
                      sBV: null,
                      orderNo: 385,
                      sportId: 17,
                      regionId: 258,
                      competitionId: 15171,
                      eventId: 599270,
                      betOutcomes: [
                        {
                          betTypeId: 385,
                          betTypeOutcomeId: 1329,
                          name: '4',
                          sBV: null,
                          odd: 1.7,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 15171,
                          eventId: 599270,
                          betId: 50781931,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 155894587,
                          description: ''

                        },
                        {
                          betTypeId: 385,
                          betTypeOutcomeId: 1330,
                          name: '5',
                          sBV: null,
                          odd: 2,
                          orderNo: 3,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 258,
                          competitionId: 15171,
                          eventId: 599270,
                          betId: 50781931,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 155894588,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: true,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: true,
                      cashBackEnabled: null,
                      id: 50781931,

                    }
                  ],
                  betsCount: 20,
                  playableBetsCount: 0,
                  homeTeam: 'Rodin, Aleksey',
                  awayTeam: 'Akimov, Igor',
                  systemStatus: 1,
                  isInOffer: true,
                  isPlayable: true,
                  cashBackEnabled: true,
                  betRadarEventId: 21961985,
                  mappingTypeId: 1,
                  siblingStandardEventId: null,
                  eventTypeId: 1,
                  id: 599270,
                  orderNo: 0

                }
              ],
              id: 15171

            }
          ],
          eventsCount: 4,
          id: 258

        },
        {
          sportId: 17,
          name: 'Russia',
          shortName: null,
          competitions: [
            {
              sportId: 17,
              regionId: 722,
              name: 'Liga Pro',
              shortName: 'RUS Liga Pro',
              eventsCount: 2,
              events: [
                {
                  code: '738',
                  dateTime: '2020-05-06T09:00:00',
                  competitionId: 14409,
                  regionId: 722,
                  sportId: 17,
                  competitionName: 'Liga Pro',
                  eventName: 'Abramov, Kirill - Merzlikin, Dmitry',
                  eventShortName: 'Abramov, Kirill - Merzlikin, Dmitry',
                  isLive: true,
                  bets: [
                    {
                      betTypeId: 86,
                      betTypeName: 'Pobednik ',
                      sBV: null,
                      orderNo: 86,
                      sportId: 17,
                      regionId: 722,
                      competitionId: 14409,
                      eventId: 599283,
                      betOutcomes: [
                        {
                          betTypeId: 86,
                          betTypeOutcomeId: 238,
                          name: '1',
                          sBV: null,
                          odd: 2.15,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 722,
                          competitionId: 14409,
                          eventId: 599283,
                          betId: 50782742,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 155896295,
                          description: ''

                        },
                        {
                          betTypeId: 86,
                          betTypeOutcomeId: 239,
                          name: '2',
                          sBV: null,
                          odd: 1.6,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 722,
                          competitionId: 14409,
                          eventId: 599283,
                          betId: 50782742,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 155896296,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: true,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: true,
                      cashBackEnabled: null,
                      id: 50782742,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '81.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 722,
                      competitionId: 14409,
                      eventId: 599283,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '81.5',
                          odd: 1.85,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 722,
                          competitionId: 14409,
                          eventId: 599283,
                          betId: 50861124,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156106583,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '81.5',
                          odd: 1.85,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 722,
                          competitionId: 14409,
                          eventId: 599283,
                          betId: 50861124,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156106584,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50861124,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '82.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 722,
                      competitionId: 14409,
                      eventId: 599283,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '82.5',
                          odd: 1.9,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 722,
                          competitionId: 14409,
                          eventId: 599283,
                          betId: 50861170,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156106680,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '82.5',
                          odd: 1.8,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 722,
                          competitionId: 14409,
                          eventId: 599283,
                          betId: 50861170,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156106681,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50861170,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '84.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 722,
                      competitionId: 14409,
                      eventId: 599283,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '84.5',
                          odd: 1.9,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 722,
                          competitionId: 14409,
                          eventId: 599283,
                          betId: 50862398,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156110695,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '84.5',
                          odd: 1.75,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 722,
                          competitionId: 14409,
                          eventId: 599283,
                          betId: 50862398,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156110696,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: true,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50862398,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '86.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 722,
                      competitionId: 14409,
                      eventId: 599283,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '86.5',
                          odd: 1.9,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 722,
                          competitionId: 14409,
                          eventId: 599283,
                          betId: 50862407,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156110713,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '86.5',
                          odd: 1.75,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 722,
                          competitionId: 14409,
                          eventId: 599283,
                          betId: 50862407,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156110714,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50862407,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '89.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 722,
                      competitionId: 14409,
                      eventId: 599283,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '89.5',
                          odd: 1.85,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 722,
                          competitionId: 14409,
                          eventId: 599283,
                          betId: 50862789,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156111561,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '89.5',
                          odd: 1.85,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 722,
                          competitionId: 14409,
                          eventId: 599283,
                          betId: 50862789,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156111562,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50862789,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '90.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 722,
                      competitionId: 14409,
                      eventId: 599283,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '90.5',
                          odd: 2,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 722,
                          competitionId: 14409,
                          eventId: 599283,
                          betId: 50862832,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156111647,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '90.5',
                          odd: 1.7,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 722,
                          competitionId: 14409,
                          eventId: 599283,
                          betId: 50862832,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156111648,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50862832,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '88.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 722,
                      competitionId: 14409,
                      eventId: 599283,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '88.5',
                          odd: 1.9,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 722,
                          competitionId: 14409,
                          eventId: 599283,
                          betId: 50862846,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156111675,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '88.5',
                          odd: 1.75,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 722,
                          competitionId: 14409,
                          eventId: 599283,
                          betId: 50862846,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156111676,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50862846,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '92.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 722,
                      competitionId: 14409,
                      eventId: 599283,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '92.5',
                          odd: 2.15,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 722,
                          competitionId: 14409,
                          eventId: 599283,
                          betId: 50863081,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156112192,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '92.5',
                          odd: 1.6,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 722,
                          competitionId: 14409,
                          eventId: 599283,
                          betId: 50863081,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156112193,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50863081,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '91.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 722,
                      competitionId: 14409,
                      eventId: 599283,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '91.5',
                          odd: 1.85,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 722,
                          competitionId: 14409,
                          eventId: 599283,
                          betId: 50863141,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156112326,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '91.5',
                          odd: 1.8,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 722,
                          competitionId: 14409,
                          eventId: 599283,
                          betId: 50863141,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156112327,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50863141,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '93.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 722,
                      competitionId: 14409,
                      eventId: 599283,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '93.5',
                          odd: 2.05,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 722,
                          competitionId: 14409,
                          eventId: 599283,
                          betId: 50863208,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156112464,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '93.5',
                          odd: 1.65,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 722,
                          competitionId: 14409,
                          eventId: 599283,
                          betId: 50863208,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156112465,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50863208,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '94.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 722,
                      competitionId: 14409,
                      eventId: 599283,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '94.5',
                          odd: 2.05,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 722,
                          competitionId: 14409,
                          eventId: 599283,
                          betId: 50863277,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156112627,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '94.5',
                          odd: 1.65,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 722,
                          competitionId: 14409,
                          eventId: 599283,
                          betId: 50863277,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156112628,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50863277,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '98.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 722,
                      competitionId: 14409,
                      eventId: 599283,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '98.5',
                          odd: 2,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 722,
                          competitionId: 14409,
                          eventId: 599283,
                          betId: 50863449,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156113063,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '98.5',
                          odd: 1.7,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 722,
                          competitionId: 14409,
                          eventId: 599283,
                          betId: 50863449,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156113064,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50863449,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '100.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 722,
                      competitionId: 14409,
                      eventId: 599283,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '100.5',
                          odd: 2.05,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 722,
                          competitionId: 14409,
                          eventId: 599283,
                          betId: 50863559,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156113312,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '100.5',
                          odd: 1.65,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 722,
                          competitionId: 14409,
                          eventId: 599283,
                          betId: 50863559,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156113313,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50863559,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '101.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 722,
                      competitionId: 14409,
                      eventId: 599283,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '101.5',
                          odd: 2.55,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 722,
                          competitionId: 14409,
                          eventId: 599283,
                          betId: 50863671,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156113648,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '101.5',
                          odd: 1.45,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 722,
                          competitionId: 14409,
                          eventId: 599283,
                          betId: 50863671,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156113650,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: true,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: true,
                      cashBackEnabled: false,
                      id: 50863671,

                    },
                    {
                      betTypeId: 385,
                      betTypeName: 'Broj gemova (5g)',
                      sBV: null,
                      orderNo: 385,
                      sportId: 17,
                      regionId: 722,
                      competitionId: 14409,
                      eventId: 599283,
                      betOutcomes: [
                        {
                          betTypeId: 385,
                          betTypeOutcomeId: 1329,
                          name: '4',
                          sBV: null,
                          odd: 2.9,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 722,
                          competitionId: 14409,
                          eventId: 599283,
                          betId: 50782778,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 155896372,
                          description: ''

                        },
                        {
                          betTypeId: 385,
                          betTypeOutcomeId: 1330,
                          name: '5',
                          sBV: null,
                          odd: 1.35,
                          orderNo: 3,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 722,
                          competitionId: 14409,
                          eventId: 599283,
                          betId: 50782778,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 155896373,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: true,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: null,
                      id: 50782778,

                    }
                  ],
                  betsCount: 19,
                  playableBetsCount: 0,
                  homeTeam: 'Abramov, Kirill',
                  awayTeam: 'Merzlikin, Dmitry',
                  systemStatus: 1,
                  isInOffer: true,
                  isPlayable: true,
                  cashBackEnabled: true,
                  betRadarEventId: 21959897,
                  mappingTypeId: 1,
                  siblingStandardEventId: null,
                  eventTypeId: 1,
                  id: 599283,
                  orderNo: 0

                },
                {
                  code: '739',
                  dateTime: '2020-05-06T09:00:00',
                  competitionId: 14409,
                  regionId: 722,
                  sportId: 17,
                  competitionName: 'Liga Pro',
                  eventName: 'Sadkov, Andrey - Pandur, Ivan',
                  eventShortName: 'Sadkov, Andrey - Pandur, Ivan',
                  isLive: true,
                  bets: [
                    {
                      betTypeId: 86,
                      betTypeName: 'Pobednik ',
                      sBV: null,
                      orderNo: 86,
                      sportId: 17,
                      regionId: 722,
                      competitionId: 14409,
                      eventId: 599284,
                      betOutcomes: [
                        {
                          betTypeId: 86,
                          betTypeOutcomeId: 238,
                          name: '1',
                          sBV: null,
                          odd: 1.27,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 722,
                          competitionId: 14409,
                          eventId: 599284,
                          betId: 50782807,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 155896432,
                          description: ''

                        },
                        {
                          betTypeId: 86,
                          betTypeOutcomeId: 239,
                          name: '2',
                          sBV: null,
                          odd: 3.2,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 722,
                          competitionId: 14409,
                          eventId: 599284,
                          betId: 50782807,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 155896433,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: true,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: null,
                      id: 50782807,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '86.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 722,
                      competitionId: 14409,
                      eventId: 599284,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '86.5',
                          odd: 1.85,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 722,
                          competitionId: 14409,
                          eventId: 599284,
                          betId: 50861255,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156106873,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '86.5',
                          odd: 1.85,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 722,
                          competitionId: 14409,
                          eventId: 599284,
                          betId: 50861255,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156106874,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50861255,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '87.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 722,
                      competitionId: 14409,
                      eventId: 599284,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '87.5',
                          odd: 2,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 722,
                          competitionId: 14409,
                          eventId: 599284,
                          betId: 50861268,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156106908,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '87.5',
                          odd: 1.7,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 722,
                          competitionId: 14409,
                          eventId: 599284,
                          betId: 50861268,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156106909,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50861268,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '85.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 722,
                      competitionId: 14409,
                      eventId: 599284,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '85.5',
                          odd: 1.85,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 722,
                          competitionId: 14409,
                          eventId: 599284,
                          betId: 50861893,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156109198,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '85.5',
                          odd: 1.85,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 722,
                          competitionId: 14409,
                          eventId: 599284,
                          betId: 50861893,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156109199,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50861893,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '88.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 722,
                      competitionId: 14409,
                      eventId: 599284,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '88.5',
                          odd: 1.9,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 722,
                          competitionId: 14409,
                          eventId: 599284,
                          betId: 50862670,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156111279,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '88.5',
                          odd: 1.8,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 722,
                          competitionId: 14409,
                          eventId: 599284,
                          betId: 50862670,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156111280,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50862670,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '89.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 722,
                      competitionId: 14409,
                      eventId: 599284,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '89.5',
                          odd: 1.95,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 722,
                          competitionId: 14409,
                          eventId: 599284,
                          betId: 50862833,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156111649,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '89.5',
                          odd: 1.75,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 722,
                          competitionId: 14409,
                          eventId: 599284,
                          betId: 50862833,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156111650,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50862833,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '90.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 722,
                      competitionId: 14409,
                      eventId: 599284,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '90.5',
                          odd: 2.1,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 722,
                          competitionId: 14409,
                          eventId: 599284,
                          betId: 50862911,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156111816,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '90.5',
                          odd: 1.65,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 722,
                          competitionId: 14409,
                          eventId: 599284,
                          betId: 50862911,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156111817,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: false,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50862911,

                    },
                    {
                      betTypeId: 310,
                      betTypeName: 'Ukupno poena',
                      sBV: '91.5',
                      orderNo: 310,
                      sportId: 17,
                      regionId: 722,
                      competitionId: 14409,
                      eventId: 599284,
                      betOutcomes: [
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1174,
                          name: 'Više',
                          sBV: '91.5',
                          odd: 2.5,
                          orderNo: 2,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 722,
                          competitionId: 14409,
                          eventId: 599284,
                          betId: 50863405,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156112949,
                          description: ''

                        },
                        {
                          betTypeId: 310,
                          betTypeOutcomeId: 1173,
                          name: 'Manje',
                          sBV: '91.5',
                          odd: 1.45,
                          orderNo: 1,
                          resultStatus: 11,
                          sportId: 17,
                          regionId: 722,
                          competitionId: 14409,
                          eventId: 599284,
                          betId: 50863405,
                          isLive: true,
                          isInOffer: true,
                          isPlayable: true,
                          cashBackEnabled: false,
                          trueOdd: null,
                          id: 156112950,
                          description: ''

                        }
                      ],
                      isFinished: false,
                      isMostBalanced: true,
                      isLive: true,
                      isInOffer: true,
                      isPlayable: false,
                      cashBackEnabled: false,
                      id: 50863405,

                    }
                  ],
                  betsCount: 0,
                  playableBetsCount: 0,
                  homeTeam: 'Sadkov, Andrey',
                  awayTeam: 'Pandur, Ivan',
                  systemStatus: 1,
                  isInOffer: true,
                  isPlayable: true,
                  cashBackEnabled: true,
                  betRadarEventId: 21959899,
                  mappingTypeId: 1,
                  siblingStandardEventId: null,
                  eventTypeId: 1,
                  id: 599284,
                  orderNo: 0

                }
              ],
              id: 14409

            }
          ],
          eventsCount: 2,
          id: 722

        }
      ],
      eventsCount: 6,
      selections: [
        {
          id: 657,
          betProductPageId: 5,
          sportId: 17,
          betTypeId: 86,
          betTypeName: 'Pobednik ',
          hasSBV: false,
          orderNumber: 1,
          sBVSelectionType: null,
          sBVExactValue: null
        },
        {
          id: 607,
          betProductPageId: 5,
          sportId: 17,
          betTypeId: 310,
          betTypeName: 'Ukupno poena',
          hasSBV: true,
          orderNumber: 2,
          sBVSelectionType: 1,
          sBVExactValue: null
        },
        {
          id: 608,
          betProductPageId: 5,
          sportId: 17,
          betTypeId: 385,
          betTypeName: 'Broj gemova (5g)',
          hasSBV: false,
          orderNumber: 3,
          sBVSelectionType: null,
          sBVExactValue: null
        }
      ]
    }
  ]
});
